import { Enums } from "@/services/dropdown-enums";

const RoleEngine = (roleType, user = null) => {
  //  roletype instead of companyRelationship
  switch (roleType) {
    case Enums.Roles.CRMAdmin:
      return handleCRMAdmin(roleType, user);
    case Enums.Roles.CRMDefaultManager:
      return handleCRMDefaultManager(roleType, user);
    case Enums.Roles.SalesManager:
    case Enums.Roles.SalesManagerReadonly:
      return handleSalesManager(roleType, user);
    default:
      return handleSalesManager(roleType, user);
  }
};

const handleCRMAdmin = (roleType, user) => {
  let roles = getDefaultRoles();
  roles = AdministratorPermissions.Get(roles, roleType);
  return roles;
};

const handleSalesManager = (roleType, user) => {
  let roles = getDefaultRoles();
  roles = applyReadOnlyRights(roles);

  // if SM
  // editRoles here
  if (roleType === Enums.Roles.SalesManager) {
    const allowedRoles = [
      "appointments",
      "lead",
      "list",
      "automation.automations",
      "automation.template",
    ];
    roles = allowGrantedRolesForEdit(roles, allowedRoles);
    roles = { ...roles, isSalesManager: true };
  }

  return roles;
};

const handleCRMDefaultManager = (roleType, user) => {
  let roles = getDefaultRoles();
  roles.analytics.view = false;
  roles.appointments.view = false;
  roles.appointments.edit = false;
  roles.analytics.dashboard.view = false;
  roles.analytics.dashboard.edit = false;
  roles.analytics.reports.view = false;
  roles.analytics.reports.edit = false;
  roles.automation.view = true;
  roles.automation.template.view = true;
  roles.settings.smsTemplate.view = true;
  roles.settings.apiKeys.view = true;
  roles.settings.emailTemplate.view = true;
  roles.sales.view = false;
  roles = { ...roles, isCRMDefaultManager: true };
  const allowedRoles = [
    "automation.template",
    "settings.smsTemplate",
    "settings.apiKeys",
    "settings.emailTemplate",
  ];
  roles = allowGrantedRolesForEdit(roles, allowedRoles);
  return roles;
};

const AdministratorPermissions = {
  Get: (roles, roleType) => {
    roles = applyAdminRoles(roles);
    return roles;
  },
};

// apply readonly rights for role type = SalesManagerReadonly
const applyReadOnlyRights = (roles) => {
  roles.analytics.view = true;
  roles.analytics.view = true;
  roles.analytics.dashboard.view = true;
  roles.analytics.reports.view = true;
  roles.appointments.view = true;
  roles.messaging.view = true;
  roles.conversation.view = true;
  // roles.report.view = true;
  roles.onBoarding.view = true;
  roles.lead.view = true;
  roles.list.view = true;
  roles.automation.template.view = true;
  roles.automation.automations.view = true;
  roles.sales.tasks.view = true;
  roles.settings.view = true;
  roles.settings.leadStatus.view = true;
  roles.settings.leadTags.view = true;
  roles.settings.taskStatus.view = true;
  roles.settings.taskType.view = true;
  roles.settings.taskPriority.view = true;
  roles.settings.customField.view = true;
  roles.settings.smsTemplate.view = true;
  roles.settings.apiKeys.view = true;
  roles.settings.emailTemplate.view = true;
  roles.settings.emailSignature.view = true;
  roles.settings.rolesAndPermissions.view = true;
  roles.settings.generalEmailSetting.view = true;
  roles.settings.advanceEmailSetting.view = true;
  return roles;
};

const administratorGrantedRoles = [
  "analytics",
  "analytics.dashboard",
  "analytics.reports",
  "appointments",
  "messaging",
  "conversation",
  // "report",
  "onBoarding",
  "lead",
  "list",
  "automation.template",
  "automation.automations",
  "sales.tasks",
  "settings",
  "settings.leadStatus",
  "settings.leadSource",
  "settings.leadTags",
  "settings.customField",
  "settings.smsTemplate",
  "settings.apiKeys",
  "settings.emailTemplate",
  "settings.emailSignature",
  "settings.rolesAndPermissions",
  "settings.generalEmailSetting",
  "settings.advanceEmailSetting",
  "settings.taskStatus",
  "settings.taskType",
  "settings.taskPriority",
];
const applyAdminRoles = (roles) => {
  roles = allowGrantedRolesForView(roles, administratorGrantedRoles);
  roles = allowGrantedRolesForEdit(roles, administratorGrantedRoles);
  return roles;
};
const applySpecialFieldsPermissions = (roles, userRoles) => {
  for (let entity in roles) {
    if (roles[entity].specialFields) {
      let keyArray = Object.keys(roles[entity].specialFields);
      keyArray.forEach((key) => {
        switch (key) {
          case "billingEmailAddress":
          case "invoiceEmail":
            if (
              // case 1
              // if company relation administrator &&
              // BM, Admin , superAdmin
              // can view and edit
              (roles.isAdminCompany &&
                (userRoles.includes(Enums.Roles.BillingManager) ||
                  userRoles.includes(Enums.Roles.Administrator) ||
                  userRoles.includes(Enums.Roles.SuperAdministrator))) ||
              // case 2
              // company relation Customer/ partner &&
              // userType default
              // can view and edit
              (!roles.isAdminCompany && roles.isDefaultUser)
            ) {
              roles[entity].specialFields[key].view = true;
              roles[entity].specialFields[key].edit = true;
            }
            break;
          case "provisionedCompanyId":
            if (
              // case 1
              // if company relation administrator &&
              // have a role  Admin/SuperAdmin/LimitedAdmin
              // can edit
              roles.isAdminCompany &&
              (userRoles.includes(Enums.Roles.LimitedAdministrator) ||
                userRoles.includes(Enums.Roles.Administrator) ||
                userRoles.includes(Enums.Roles.SuperAdministrator))
            ) {
              roles[entity].specialFields[key].view = true;
              roles[entity].specialFields[key].edit = true;
            }
            break;
          default:
            break;
        }
      });
    }
  }
  return roles;
};
const allowGrantedRolesForView = (roles, allowedRoleArray) => {
  let permission = "view";
  let value = true;
  allowedRoleArray.forEach((roleName) => {
    roles = createNestedObjectFromStringAndApplyValue(
      roles,
      roleName,
      value,
      permission
    );
  });
  return roles;
};
const allowGrantedRolesForEdit = (roles, allowedRoleArray) => {
  let permission = "edit";
  let value = true;
  allowedRoleArray.forEach((roleName) => {
    roles = createNestedObjectFromStringAndApplyValue(
      roles,
      roleName,
      value,
      permission
    );
  });
  return roles;
};
const denyGrantedRolesForEdit = (roles, allowedRoleArray) => {
  allowedRoleArray.forEach((roleName) => {
    roles[roleName].edit = false;
  });
  return roles;
};

const getDefaultRoles = () => {
  return {
    analytics: {
      view: true,
      dashboard: { view: false, edit: false },
      reports: { view: false, edit: false },
      editor: { view: true, edit: true },
    },
    messaging: {
      view: false,
      edit: false,
    },
    conversation: {
      view: false,
      edit: false,
    },
    // report: {
    //   view: false,
    //   edit: false,
    // },
    onBoarding: {
      view: false,
      edit: false,
    },
    lead: {
      view: false,
      edit: false,
    },
    list: {
      view: false,
      edit: false,
    },
    appointments: {
      view: false,
      edit: false,
    },
    automation: {
      view: true,
      template: { view: false, edit: false },
      automations: { view: false, edit: false },
    },
    sales: {
      view: true,
      tasks: { view: false, edit: false },
    },
    settings: {
      view: true,
      edit: false,
      leadStatus: { view: false, edit: false },
      leadSource: { view: false, edit: false },
      leadTags: { view: false, edit: false },
      customField: { view: false, edit: false },
      generalEmailSetting: { view: false, edit: false },
      advanceEmailSetting: { view: false, edit: false },
      smsTemplate: { view: false, edit: false },
      apiKeys: { view: false, edit: false },
      emailTemplate: { view: false, edit: false },
      emailSignature: { view: false, edit: false },
      rolesAndPermissions: { view: false, edit: false },
      taskStatus: { view: false, edit: false },
      taskType: { view: false, edit: false },
      taskPriority: { view: false, edit: false },
    },
  };
};

export default RoleEngine;

function createNestedObjectFromStringAndApplyValue(
  roles,
  string,
  value,
  permission = "view"
) {
  const parts = string.split(".");
  let currentObj = roles;
  for (let i = 0; i < parts.length - 1; i++) {
    const part = parts[i];

    if (!currentObj[part]) {
      currentObj[part] = {};
    }

    currentObj = currentObj[part];
  }

  const lastKey = parts[parts.length - 1];
  currentObj[lastKey][permission] = value;

  return roles;
}
